import {
    Component,
    DestroyRef,
    EventEmitter,
    forwardRef,
    inject,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
    FormBuilder,
    NG_VALUE_ACCESSOR,
    ReactiveFormsModule,
} from '@angular/forms';
import { WdxFormFieldModule } from '@wdx/shared/components/wdx-form-field';
import {
    CustomInputHandler,
    CustomOutputHandler,
    jsonSerialiser,
    WdxJsonViewerComponent,
} from '@wdx/shared/components/wdx-json-editor';
import { IWrappedFormComponent } from '@wdx/shared/infrastructure/form-framework';
import { TranslateTokenisedStringPipe } from '@wdx/shared/utils';
import { BaseReactiveFormAdapterClass } from '../../../classes/base-reactive-form-adapter.class';

@Component({
    selector: 'clmi-form-json-editor',
    templateUrl: './form-json-editor.component.html',
    styleUrls: ['./form-json-editor.component.scss'],
    imports: [
        WdxFormFieldModule,
        WdxJsonViewerComponent,
        TranslateTokenisedStringPipe,
        ReactiveFormsModule,
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FormJsonViewerComponent),
            multi: true,
        },
    ],
})
export class FormJsonViewerComponent
    extends BaseReactiveFormAdapterClass
    implements IWrappedFormComponent, OnInit
{
    private destroyRef = inject(DestroyRef);
    private fb: FormBuilder = inject(FormBuilder);
    @Input() customInputHandler?: CustomInputHandler;
    @Input() customOutputHandler: CustomOutputHandler = jsonSerialiser;

    @Output() blurred = new EventEmitter();

    public form = this.fb.group({
        jsonViewer: [null as string, []],
    });

    writeValue(value: string) {
        this.form.controls.jsonViewer.setValue(value, { emitEvent: false });
    }

    ngOnInit(): void {
        this.form.controls.jsonViewer.valueChanges
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((value) => this.onChange(value));
    }
}
